<template>
  <div class="backdrop">
    <div class="popup" v-on-clickaway="hideDialog">
      <h2> About the Organizers </h2>
      <font-awesome-icon :icon="['fas', 'times']" size="1x" class="x-button"
        @click="hideDialog">
      </font-awesome-icon>
        <div class="contact-owner">
          <contact-user :receiverUserName="owner.userName" v-if="!isMyEvent"
            buttonText="Contact Owner"
            :receiverDisplayName="owner.displayName" class="contact-user"/>
        </div>
      <div class="users-container">
        <span class="role-title">Owner</span>
        <div class="user-container">
          <router-link :to="`/user/${owner.userName}`">
            <img class="user-pic" :src="owner.profilePic" v-if="owner.profilePic"/>
            <font-awesome-icon v-else
              :icon="['fa', 'user-circle']" size="2x" :style="{ color: 'lightgray' }"/>
            <span>{{owner.displayName}}</span>
          </router-link>
        </div>
        <div class="owner-about" v-if="owner.about">{{owner.about}}</div>
        <div v-if="isOwnerPhoneVerified" class="verified-phone">
          <font-awesome-icon :icon="['fas', 'phone']" size="1x">
          </font-awesome-icon>
          <span class= "linked-account">Verified Phone</span>
        </div>
        <div v-if="ownerLinkedAccounts.length > 0" class="owner-linked-accounts-container">
          <div v-for="(linkedAccount, i) in ownerLinkedAccounts" :key="i"
            class="owner-linked-account-container">
            <div :class="`${linkedAccount.connection}-icon`">
              <font-awesome-icon
                :icon="['fab', socialNetworks
                  .find(network => network.id === linkedAccount.connection).icon]"
                size="2x"/>
            </div>
            <span class= "linked-account">Connected</span>
          </div>
        </div>
      </div>
      <div class="users-container" v-if="editors.length > 0">
        <span class="role-title">Editors</span>
        <div v-for="editor in editors" :key="editor.id" class="user-container">
          <router-link :to="`/user/${editor.userName}`">
            <img class="user-pic" :src="editor.profilePic" />
            <span>{{editor.displayName}}</span>
          </router-link>
        </div>
      </div>
      <div class="users-container" v-if="viewers.length > 0">
        <span class="role-title">Viewers</span>
        <div v-for="viewer in viewers" :key="viewer.id" class="user-container">
          <router-link :to="`/user/${viewer.userName}`">
            <img class="user-pic" :src="viewer.profilePic" />
            <span>{{viewer.displayName}}</span>
          </router-link>
        </div>
      </div>
      <span class="close" @click="hideDialog">Close</span>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapState } from 'vuex';

export default {
  name: 'team-popup',
  mixins: [clickaway],
  props: {
    team: {
      type: Array,
      default: () => [],
    },
    ownerLinkedAccounts: {
      type: Array,
      default: () => [],
    },
    isOwnerPhoneVerified: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('user', ['userName']),
    ...mapState('auth', ['backendAxios', 'socialNetworks']),
    owner() {
      return this.team.find(member => member.role === 'owner').user;
    },
    editors() {
      return this.team
        .filter(member => member.role === 'editor')
        .map(member => member.user);
    },
    viewers() {
      return this.team
        .filter(member => member.role === 'viewer')
        .map(member => member.user);
    },
    isMyEvent() {
      return this.owner.userName === this.userName;
    },
  },
  methods: {
    hideDialog() {
      this.$emit('close');
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.backdrop {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.3s;
  z-index: 100;
}

.popup {
  position: absolute;
  text-align: center;
  max-width: 25rem;
  padding: 0 0 2rem 0;
  width: 95%;
  max-height: 75%;
  overflow: scroll;
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 0.375rem;
  -webkit-font-smoothing: antialiased;
}

.close {
  position: fixed;
  color: #444444;
  left: 0;
  right: 0;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  &:hover {
    color: #282828;
    text-decoration: underline;
  }
}

.role-title {
  font-size: 1.15rem;
  font-weight: 600;
  margin-top: 1rem;
}

.users-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 1rem;
}

.user-container {
  margin: 0.5rem;
  font-size: 1.15rem;
}

.user-container > a {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  color: #444444;
  text-align: left;
  margin: 0.5rem 0;
  &:hover {
    color: #0b66f0;
    fill: #0b66f0;
    text-decoration: underline;
}
}

.user-pic {
  border-radius: 1.5rem;
  height: 3rem;
  width: 3rem;
  margin-right: 1rem;
}

.x-button {
  position: absolute;
  top: 0.625rem;
  right: 0.25rem;
  margin: 1rem;
  cursor: pointer;
  &:hover {
    filter: brightness(0.6);
    -webkit-filter: brightness(0.6);
  }
}

.facebook-icon {
  color: $facebook;
}

.google-icon {
  color: $google;
}

.twitter-icon {
  color: $twitter;
}

.twitch-icon {
  color: $twitch;
}

.linkedin-icon {
  color: $linkedin;
}

.owner-linked-accounts-container {
  display: flex;
  flex-direction: column;
}

.owner-linked-account-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem;
  margin: 0 0.5rem;
}
.verified-phone {
  padding: 0.5rem;
  margin: 0 0.5rem;
}

.linked-account{
  margin: 0 0.5rem;
}
.owner-about{
  text-align: start;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}

.contact-owner {
  width:100%;
  display:flex;
  justify-content: center;
  margin: 2rem 0 0 0;
}

</style>
